import { render, staticRenderFns } from "./aggregation-card.vue?vue&type=template&id=7ae0e9a0"
import script from "./aggregation-card.vue?vue&type=script&lang=js"
export * from "./aggregation-card.vue?vue&type=script&lang=js"
import style0 from "./aggregation-card.vue?vue&type=style&index=0&id=7ae0e9a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports